<header class="flex justify-between items-center h-24 p-6">
  <div>
    <a class="w-32 block" href="https://www.{{triconDomain}}.com" title="Home">
      <img src="../../assets/images/new_tricon_logo.png" alt="Tricon" />
    </a>
  </div>
    <div class="flex justify-start items-center">
        <button (click)="callTricon()">
            <mat-icon class="relative text-vivid-orange mx-2 text-3xl align-middle" fontSet="material-icons-outlined">phone
            </mat-icon>
        </button>
        <div class="text-vivid-orange mx-2 text-base align-middle sm:inline hidden">844&nbsp;874&nbsp;2661</div>
    </div>
</header>
<hr style="color: #FF3C00; height: 8px; border: none; background-color: #FF3C00; position: relative; z-index: 1000;">
